import { Col, Row } from "antd";

export function MainTeach(props) {
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <div className="main-teacher">
          <MainTeacher />
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="main-teacher-ph">
          <MainTeacherPh />
        </div>
      </Col>
    </Row>
  )
}

function MainTeacher(props) {
  return (
    <div className="mainteacher-box">
      <div className="main-teacher-text1">
        <div className="cn-main-teacher-text1">主讲师</div>
        <div className="en-main-teacher-text1"><span>LEAD </span><span> LECTURER</span></div>
      </div>
      <div className="krenz-intro">
        <div className="krenz-intro-logo-ajust"><div className="krenz-intro-logo"></div></div>
        <div className="vertival-line-ajust"><div className="vertival-line"> </div></div>
        <div className="krenz-intro-text">
          <div className="krenz-intro-text1"></div>
          <div className="ajust-div">
            <div className="krenz-intro-text2"><span>KRENZ’S ARTWORK 绘画教室创办人及主讲师</span></div>
            <div className="krenz-intro-text3"><span>拥有业界十余年丰富教学经验，深入浅出的独创授课方式获得同学青睐</span></div>
            <div className="krenz-intro-text4">
              <div className="social-media">
                <div className="en-social-media"><span>KRENZ'S SOCIAL MEDIA</span></div>
                <div className="cn-social-media"><span>KRENZ的社交媒体</span></div>
              </div>
              <div className="social-icon">
                <a href="https://www.cctalk.com/m/group/82776894" rel="noreferrer" target="_blank"><div className="social-icon-cc"></div></a>
                <a href="https://space.bilibili.com/181578039" rel="noreferrer" target="_blank"><div className="social-icon-bilibili"></div></a>
                <a href="https://www.weibo.com/u/1926245291" rel="noreferrer" target="_blank"><div className="social-icon-weibo"></div></a>
                <a href="https://www.zhihu.com/org/kkmo-fa-xue-yuan" rel="noreferrer" target="_blank"> <div className="social-icon-zhihu"></div></a>
                {/* <a href="https://www.artstation.com/krenz" rel="noreferrer" target="_blank"><div className="social-icon-art"></div></a> */}

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="teachingmiddleimg"></div>
    </div>
  )
}

function MainTeacherPh(props) {
  return (
    <div className="mainteacher-bg">
      <div className="top-text">
        <div className="cn-top-text">主讲人</div>
        <div className="en-top-text"><span>LEAD</span><span> LECTURER</span></div>
      </div>
      <div className="down-text">
        <div className="mainteacher-logo"></div>
        <div className="ph-text-intro">
          <div className="ph-krenz-head-extra1"><div className="ph-krenz-head"></div></div>
          <div className="extra"><div className="ph-line-vertical"></div></div>
          <div className="ph-intro-text">
            <div><span>KRENZ'S </span><span> ARTWORK</span><span> 绘画教室创办人及主讲师</span></div>
            <div><span>拥有业界十余年丰富教学经验</span></div>
            <div><span>深入浅出的独创授课方式获得同学青睐</span></div>
          </div>
        </div>
        <div className="ph-social-media">
          <div className="social-media-text">
            <div className="en-social-media-text"><span>KRENZ'S SOCIAL MEDIA</span></div>
            <div className="cn-social-media-text"><span>KRENZ的社交媒体</span></div>
          </div>
          <div className="ph-social-icon">
            <a href="https://www.cctalk.com/m/group/82776894" rel="noreferrer" target="_blank"><div className="ph-cc"></div></a>
            <a href="https://space.bilibili.com/181578039" rel="noreferrer" target="_blank"><div className="ph-bili"></div></a>
            <a href="https://www.weibo.com/u/1926245291" rel="noreferrer" target="_blank"><div className="ph-weibo"></div></a>
            <a href="https://www.zhihu.com/org/kkmo-fa-xue-yuan" rel="noreferrer" target="_blank"><div className="ph-zhihu"></div></a>
            {/* <a href="https://www.artstation.com/krenz" rel="noreferrer" target="_blank"><div className="ph-art"></div></a> */}

          </div>
        </div>
      </div>
    </div>
  )
}